module.exports = __webpack_public_path__ + "static/media/delivered-active.b8126334.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/delivered-active.svg
// module id = ./src/assets/icons/delivered-active.svg
// module chunks = 0